import styled from 'styled-components';
import AgreementOfferPrivacyImg from '@/assets/img/jejuro-offer-privacy.png';
import { ContentWrapper } from '@/components/reservationDetails/commonStyles';

const AgreementOfferPrivacy = () => {
  return (
    <ContentWrapper>
      <InnerWrapper>
        <img
          src={AgreementOfferPrivacyImg}
          width='100%'
          alt='개인정보 제3자 제공 동의'
        />
      </InnerWrapper>
    </ContentWrapper>
  );
};

export default AgreementOfferPrivacy;

const InnerWrapper = styled.div`
  margin-top: 60px;
`;
